import { VortexSetupVars } from 'mapistry-shared';
import { http } from 'mapistry-shared/api';

export async function fetchVortexSetupVars() {
  const res = await http.get<VortexSetupVars>('api/page-setup-vars/vortex');
  return res.data;
}
